import { IS_IOS } from '@weblite/logic-toolkit'
import { IS_SAFARI } from '$func/environmentInfo'

export interface OnboardingAction {
  action: string
  time: string
}

export enum IosSafariOnboarding {
  IOS_SYNC_CONTACTS = 'iOSSyncContacts',
}

export enum CommonOnboarding {
  // CREATE_ROOM_FAB = 'createRoomFab',
  CHAT_WAPP_BUTTON = 'chatWappButton',
  CREATE_CHANNEL_BUTTON = 'createChannelButton',
  COURSE_VITRINE_SETTING_BUTTON = 'courseVitrineSettingButton',
  CLASSROOM = 'classroom',
  POLL = 'poll',
  UNIT_TEST = 'unitTest',
  HOME_WORK = 'homeWork',
  DESCRIPTIVE_EXAM = 'descriptiveExam',
  POST = 'post',
  TEST_EXAM = 'testExam',
  CREATE_HALL = 'createHall',
  CHANNEL_SETTINGS = 'channelSettings',
  CHANNEL_PROFILE = 'channelProfile',
  TEACHER_PLAYGROUND_CHANNEL = 'teacherPlaygroundChannel',
  CREATE_COURSE = 'createCourse',
}

export type IOnboarding = CommonOnboarding | IosSafariOnboarding

export interface ActionsState {
  actions: Set<string>
  fetched: boolean
}

export const onboardingActions = [
  ...Object.values(CommonOnboarding || {}),
  ...(IS_IOS && IS_SAFARI ? Object.values(IosSafariOnboarding) : []),
]
